import React, { useEffect, useState } from "react"
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from "react-redux"
import BuyerForm from "./BuyerForm"
import ItemsForm from "./ItemsForm"
import TransactionForm from "./TransactionForm"
import { generateInvoiceThunk } from "../thunks/invoice";
import { clearInvoiceFormSuccessful } from "../actions/invoice/actionCreators";

function InvoiceForm() {
    const invoiceForm: NewInvoiceDetails = useSelector((state: AppState) => state.invoiceForm)
    const invoiceUrl: string = useSelector((state: AppState) => state.invoiceUrl)
    const apiError: any = useSelector((state: AppState) => state.apiError)
    const [isLoading, setIsLoading] = useState(true)
    const dispatch: Dispatch<any> = useDispatch()

    useEffect(() => {
        setIsLoading(false)
    }, [invoiceUrl, apiError])

    const generateInvoice = (e: React.SyntheticEvent) => {
        e.preventDefault()
        dispatch(generateInvoiceThunk(invoiceForm))
        setIsLoading(true)
    }

    const clearInvoice = () => {
        dispatch(clearInvoiceFormSuccessful())
    }

    return (
        <form className="invoice-form" onSubmit={(e: React.SyntheticEvent) => generateInvoice(e)}>
            <div className="form-container">
                <h2> Transaction Details </h2>
                <TransactionForm />
            </div>
            <div className="form-container">
                <h2> Items </h2>
                <ItemsForm />
            </div>
            <div className="form-container">
                <h2> Buyer Details </h2>
                <BuyerForm />
            </div>
            <div className="submit-btn-container">
                <button type="button" className="btn red large" onClick={() => clearInvoice()}> Clear </button>
                <button type="submit" className="btn green large"> { isLoading ? <div className='bar-loader'/> : 'Generate Invoice Link' } </button>
            </div>
        </form>
    )
}

export default InvoiceForm